module.exports = __webpack_public_path__ + "static/media/shadowMacbook.59daf866.png";